import { render, staticRenderFns } from "./_rezeki.vue?vue&type=template&id=bffc252c&scoped=true&lang=pug&"
import script from "./_rezeki.vue?vue&type=script&lang=js&"
export * from "./_rezeki.vue?vue&type=script&lang=js&"
import style0 from "./_rezeki.vue?vue&type=style&index=0&id=bffc252c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bffc252c",
  null
  
)

export default component.exports